module.exports = __webpack_public_path__ + "static/media/3.199f6fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/hero/3.png
// module id = 377
// module chunks = 0